<template>
  <transition name="expend">
    <div v-if="state" class="include-url" :style="{ '--max': maxHeight}">
      <div class="header">
        <div class="notice">
          <i class="icon icon--bell-till"></i>
          <span v-html="$t(`journey.nodeReport.includeUrl.textInfo.${mode}`)"></span>
        </div>
        <div class="mode-switch">
          <div class="btf-switch" @click="changeMode()">
            <div class="b-base">
                <i class="icon size-20" :class="[switchData.baseIcon]"></i>
                <i class="icon size-20" :class="[switchData.onIcon]"></i>
            </div>
            <div class="b-button" :class="{on: mode === 'chart'}">
                <div class="button-wrap">
                    <i class="icon size-20" :class="[`${switchData.baseIcon}`]"></i>
                    <i class="icon size-20" :class="[`${switchData.onIcon}`]"></i>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="include-url-body">
        <template v-if="mode ==='list'">
          <div class="include-url-list" :style="{minHHeight: '80px'}">
            <table>
                <thead>
                <tr>
                  <th class="item--rank">{{ $t('common.rank') }}</th>
                  <th class="item--url">{{ $t('journey.nodeReport.includeUrl.title') }}</th>
                  <th class="item--session">{{ $t('common.pv') }}</th>
                </tr>
                </thead>
                <tbody>
                  <template v-if="pageList.length > 0 && !loading">
                    <tr v-for="(url, i) in pageList" :key="`ranking${i + (pageInfo.numToPage *( pageInfo.page - 1)) + 1}`">
                      <td class="item--rank">
                        {{ i + (pageInfo.numToPage * (pageInfo.page - 1)) + 1 }}
                      </td>
                      <td class="item--url">
                        <a :href="`${url.url}`" target="_blank" v-if="url.url && url.url !== 'Direct'">
                          <span class="url">{{ url.url }}</span>
                        </a>
                        <span v-else class="url">Direct</span>
                      </td>
                      <td class="item--session">
                        {{ url.pvPercentage }}%
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <template v-if="loading">
                <div class="loader">
                  <ba-loading :showLoadingText="true" />
                </div>
              </template>
              <div v-if="includeData && includeData.length > pageInfo.numToPage" class="pagination-wrap">
                <div class="btf-pagination">
                  <div class="prev-btn control" :class="{disabled: disablePrev}" @click="selectedToPrev">
                    <i class="icon icon--arrow-left-small-black size-16"></i>
                  </div>
                  <div class="next-btn control" :class="{disabled: disableNext}" @click="selectedToNext">
                    <i class="icon icon--arrow-right-small-black size-16"></i>
                  </div>
                  <div class="pagination">
                    <div class="current num-block">{{ pageInfo.page }}</div>
                    <span>/</span>
                    <div class="total">{{ pageLength }}</div>
                  </div>
                </div>
              </div>
          </div>
        </template>
        <template v-else>
          <div class="include-url-chart">
            <div class="chart">
              <AppChart chartType="pie"
                        class="app-chart"
                        :chartOptions="pvChartOptions"
                        :width="140"
                        :height="140" />
            </div>
            <div class="chart-labels">
              <div class="label-item" v-for="(label, i) in pvChartOptions.series[0].data" :key="label.name">
                <div class="mark" :style="{ backgroundColor: pvChartOptions.color[i]}"></div>
                <div v-if="label.name !== 'etc'" class="name" v-btf-tooltip="{ contents:label.url, size: 200, padding: '16px 20px' }">{{ label.name }}</div>
                <div v-else class="name">{{ label.name }}</div>
                <div class="value">{{ label.value }}%</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import AppChart from '@/components/chart'
import BaLoading from '@/components/ui/ba/Loading'

export default {
  name: 'IncludeURL',
  components: { AppChart, BaLoading },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    state: {
      type: Boolean,
      default: false
    },
    includeData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      mode: 'list', // list || chart
      switchData: {
        baseIcon: 'icon--type-of-list',
        onIcon: 'icon--chart-pie-line'
      },
      pageInfo: {
        page: 1,
        numToPage: 5
      },
      IncludeList: [],
      pageList: [],
      pageLength: 1,
      pvChartOptions: {
        series: [
          {
            type: 'pie',
            data: [],
            hoverAnimation: false,
            cursor: 'default',
            label: {
              show: false
            },
            tooltip: {
              show: false
            },
            silent: true,
            radius: ['35%', '100%'],
            width: 140,
            height: 140
          }
        ],
        color: ['#1199AF', '#9FCE12', '#FFCC00', '#BAA7D5', '#77749A', '#EBEBEB']
      }
    }
  },
  computed: {
    disablePrev () {
      return this.pageInfo.page === 1
    },
    disableNext () {
      return this.pageInfo.page === this.pageLength
    },
    maxHeight () {
      return 165 + (51 * this.pageList.length) + 50
    }
  },
  watch: {
    includeData () {
      this.pageLength = Math.ceil(this.includeData.length / this.pageInfo.numToPage)
      this.setPageList()
    }
  },
  created () {
    this.pageList = []
  },
  mounted () {
    if (this.includeData.length > 0) {
      this.pageLength = Math.ceil(this.includeData.length / this.pageInfo.numToPage)
      this.setPageList()
    }
  },
  methods: {
    changeMode () {
      this.mode = this.mode === 'list' ? 'chart' : 'list'
      if (this.mode === 'chart') this.setChartList()
    },
    selectedToPrev () {
      this.pageInfo.page--
      this.setPageList()
    },
    selectedToNext () {
      this.pageInfo.page++
      this.setPageList()
    },
    setPageList () {
      const startIndex = (this.pageInfo.page - 1) * this.pageInfo.numToPage
      const endIndex = startIndex + this.pageInfo.numToPage
      this.pageList = this.includeData.slice(startIndex, endIndex)
    },
    setChartList () {
      let total = 0
      const chartList = this.includeData.slice(0, 5).map((item, i) => {
        total = total + Number(item.pvPercentage)
        return {
          name: `${i + 1}st`,
          value: item.pvPercentage,
          url: item.url
        }
      })
      if (this.includeData.length > 5) {
        chartList.push({
          name: `etc`,
          value: (100 - total).toFixed(1),
          url: ``
        })
      }
      this.pvChartOptions.series[0].data = chartList
    }
  }
}
</script>

<style lang="scss" scoped>
.include-url {
  --max: 0;
  overflow: hidden;
  max-height: var(--max)+px;
  .include-url-body {
    transition: all 250ms ease-in-out;
    padding-bottom: 60px;
  }
  * {
    box-sizing: border-box;
  }
  .header {
    display: flex;
    align-items: center;
    gap: 40px;
    .notice {
      position: relative;
      font-size: 12px;
      line-height: 1.5;
      color: #0E90A5;
      padding: 25px 0 28px 27px;

      i {
        position: absolute;
        top: 25px;
        left: 2px;
      }
    }
  }
  .pagination-wrap {
    margin-top: 10px;
  }
}
.btf-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 9px;
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    line-height: 1;
    color: #888;
    .num-block {
      width: 32px;
      height: 32px;
      padding: 10px 0;
      line-height: 1;
      outline: 1px solid #BBB;
      border-radius: 4px;
      text-align: center;
    }
  }
  .control {
    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    outline: 1px solid #D7D7D7;
    text-align: center;
    width: 24px;
    height: 24px;
    line-height: 1;
    &.next-btn {
      order: 1
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.06);
    }
    &.disabled {
      pointer-events: none;
      opacity: 0.3;
      // background-color: #ebebeb;
    }
  }
}

.btf-switch {
    cursor: pointer;
    width: 90px;
    height: 32px;
    border-radius: 16px;
    outline: 1px solid #D7D7D7;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    margin: 1px;
    .b-base {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.1);
        box-shadow: 0px 1px 1px 1px rgba(0, 0, 0, 0.04) inset 0 0 1px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 15px;
        box-sizing: border-box;
        & > i.icon {
          opacity: 0.2;
        }
    }
    .button-wrap {
        width: 90px;
        padding: 6px 15px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        transition: transform 200ms;
        //opacity: 0.4;
        box-sizing: border-box;
    }
    .b-button {
        position: absolute;
        z-index: 10;
        width: 50px;
        height: 32px;
        top: 0;
        left: 0;
        border-radius: 16px;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.20);
        overflow: hidden;
        transition: all 200ms;
        &.on {
            transform: translateX(40px);
            .button-wrap {
                transform: translateX(-40px);
            }
        }
    }
}
.num-block {
  width: 32px;
  height: 32px;
  padding: 10px 4px;
  line-height: 1;
  outline: 1px solid var(--color-border);
  border-radius: 4px;
  text-align: center;
  font-size: 13px;
  &.current {
    color: #FC004E;
    font-weight: 500;

  }
}
.include-url-list {
  .loader {
    position: relative;
    height: 120px;
  }
  table {
    font-size: 13px;
    width: 100%;
    th {
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #767676;
      padding: 13px 10px 7px 10px;
      border-bottom: 1px solid #bbbbbb;
      font-size: 13px;
      &.item--rank {
        text-align: center;
        padding-right: 0;
        padding-left: 0;
      }
      &.item--url {
        text-align: center;
      }
      &.item--session {
        text-align: right;
        padding-right: 0;
        padding-left: 0;
      }
    }
    td {
      border-bottom: 1px solid #ebebeb;
      vertical-align: middle;
      line-height: 1.23;
      font-size: 13px;
      font-weight: normal;
      color: #444;
      a {
        color: #444;
      }
      &.item--rank {
        padding: 16px 0;
        width: 40px;
        line-height: 18px;
        font-size: 14px;
        text-align: center;
        &.big {
          font-size: 12px;
        }
      }
      &.item--url {
        line-height: 14px;
        padding: 10px;
        .url {
          word-break: break-all;
        }
      }
      &.item--session {
        text-align: right;
        width: 55px;
        white-space: nowrap;
        padding: 10px 0;
        &.big {
          font-size: 12px;
        }
      }
    }
  }
}
.include-url-chart {
  display: flex;
  gap: 38px;
  .chart {
    margin: 0 15px;
  }
  .chart-labels {
    flex-grow: 1;
    .label-item {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 0;
      margin-bottom: 5px;
      .mark {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 100%;
        z-index: 1;
        width: 8px;
        height: 8px;
        border-radius: 50%;;
      }
      .name, .value {
        background-color: #fff;
        padding: 5px;
      }
      &:before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        z-index: -1;
        width: 99%;
        height: 5px;
        background-image: radial-gradient(#979797 25%, #fff 20%);
        background-size: 5px 5px;
      }
    }
  }
}
.expend-leave-active,
.expend-enter-active {
  transition: all 250ms ease-in-out;
  max-height: 470px;
}
.expend-enter,
.expend-leave-to {
  max-height: 0;
}
</style>
